import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.js';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * ProtectedRoute — wraps pages that require authentication + role-based access.
 * @param {Object} props
 * @param {string[]} props.allowedRoles - Array of roles that can access this route (e.g., ['owner', 'staff'])
 * @param {React.ReactNode} props.children
 */
export const ProtectedRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated, isLoading, isInitialized, accessType } = useAuth();

  // Still loading auth state
  if (isLoading || !isInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          bgcolor: '#EBEBEF',
          gap: 2,
        }}
      >
        <CircularProgress size={32} sx={{ color: '#4527A0' }} />
        <Typography variant="body2" sx={{ color: '#86868B', fontWeight: 500 }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  // Not authenticated → login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated but role not allowed
  if (allowedRoles && !allowedRoles.includes(accessType)) {
    return <Navigate to="/home" replace />;
  }

  return children;
};
